import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { PurchaseOrderActions } from "../actions/purchase-order.actions";
import { PurchaseOrdersState } from "../models/purchase-orders-state";

const initialState: PurchaseOrdersState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	// Orders list
	on(PurchaseOrderActions.orders.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(PurchaseOrderActions.orders.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		orders: action.orders,
		loading: false,
		hasLoaded: true
	})),
	on(PurchaseOrderActions.orders.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(PurchaseOrderActions.orders.invalidate, (state) => ({
		...state,
		orders: undefined,
		hasLoaded: false,
		loading: true
	})),

	// Selected order
	on(PurchaseOrderActions.selectedOrder.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		selectedOrder: action.order
	})),
	on(PurchaseOrderActions.selectedOrder.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(PurchaseOrderActions.selectedOrder.clear, (state) => ({
		..._.omit(state, "error"),
		selectedOrder: undefined
	})),

	// Status update
	on(PurchaseOrderActions.status.updateSuccess, (state, action) => ({
		...state,
		selectedOrder: action.order
	})),

	// Templates list
	on(PurchaseOrderActions.templates.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(PurchaseOrderActions.templates.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		templates: action.templates,
		loading: false,
		templatesHasLoaded: true
	})),
	on(PurchaseOrderActions.templates.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(PurchaseOrderActions.templates.invalidate, (state) => ({
		...state,
		templates: undefined,
		templatesHasLoaded: false
	}))
);

export function purchaseOrderReducer(
	state: PurchaseOrdersState | undefined,
	action: Action
): PurchaseOrdersState {
	return reducer(state, action);
}
